export default __webpack_public_path__ + "static/media/edit_icon_hover.2fcd6b0e.svg";